import { render, staticRenderFns } from "./ArqComprovanteSantander.vue?vue&type=template&id=77a84f65&"
import script from "./ArqComprovanteSantander.vue?vue&type=script&lang=js&"
export * from "./ArqComprovanteSantander.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports